export const getUrlWithToken = (url: string): string => {
  const token = window?.currentProvider?.getToken() || '';

  if (url.includes('token')) return url;

  if (token) {
    return url.includes('&') ? `${url}&token=${token}` : `${url}?token=${token}`;
  }

  return url;
};
